import { createEffect } from 'effector';
import { api } from '../../api/axiosInstance.js';

export const getInvestProjectsFx = createEffect().use(async (filters) => {
  console.log('🚀 ~  ~ filters: ', filters);
  return (await api(true).post('/dashboard-projects/', filters)).data;
});

export const getInvestProjectsRegionFx = createEffect().use(async (filters) => {
  return (await api(true).post(`/dashboard-projects/region`, filters)).data;
});

export const getInvestProjectsActivityFx = createEffect().use(
  async (filters) => {
    return (await api(true).post(`/dashboard-projects/activity`, filters)).data;
  }
);

export const getInvestProjectsDistrictFx = createEffect().use(
  async (filters) => {
    return (await api(true).post(`/dashboard-projects/district`, filters)).data;
  }
);

export const getInvestProjectsSubActivityFx = createEffect().use(
  async (filters) => {
    return (await api(true).post(`/dashboard-projects/sub-activity`, filters))
      .data;
  }
);
